<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南航道桥新风阀</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-nb11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB11" class="state-info right-pos sign-container">
                <p class="segment-name">NB11梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB11" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB7" class="state-info right-pos sign-container">
                <p class="segment-name">NB7梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB7" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB3" class="state-info right-pos sign-container">
                <p class="segment-name">NB3梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNB3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-01">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="error01" class="state-info right-pos sign-container">
                <p class="segment-name">01梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClass01" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ4" class="state-info left-pos sign-container">
                <p class="segment-name">NZ4梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ8" class="state-info left-pos sign-container">
                <p class="segment-name">NZ8梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ8" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ12" class="state-info left-pos sign-container">
                <p class="segment-name">NZ12梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ12" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz16">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ16" class="state-info left-pos sign-container">
                <p class="segment-name">NZ16梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassNZ16" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南航道桥排气阀</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-nb13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB13" class="state-info right-pos sign-container">
                <p class="segment-name">NB13梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB13" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB9" class="state-info right-pos sign-container">
                <p class="segment-name">NB9梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB9" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB5" class="state-info right-pos sign-container">
                <p class="segment-name">NB5梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB5" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNB1" class="state-info right-pos sign-container">
                <p class="segment-name">NB1梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNB1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ2" class="state-info left-pos sign-container">
                <p class="segment-name">NZ2梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ2" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ6" class="state-info left-pos sign-container">
                <p class="segment-name">NZ6梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ9" class="state-info left-pos sign-container">
                <p class="segment-name">NZ9梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ9" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ13" class="state-info left-pos sign-container">
                <p class="segment-name">NZ13梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ13" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz17">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorNZ17" class="state-info left-pos sign-container">
                <p class="segment-name">NZ17梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassNZ17" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "airValve",
  data() {
    return {
      loading: true,
      timer: null,

      valveClassNB13: "",
      valveClassNB11: "",
      valveClassNB9: "",
      valveClassNB7: "",
      valveClassNB5: "",
      valveClassNB3: "",
      valveClassNB1: "",
      valveClass01: "",
      valveClassNZ2: "",
      valveClassNZ4: "",
      valveClassNZ6: "",
      valveClassNZ8: "",
      valveClassNZ9: "",
      valveClassNZ12: "",
      valveClassNZ13: "",
      valveClassNZ16: "",
      valveClassNZ17: "",

      errorNB13: "",
      errorNB11: "",
      errorNB9: "",
      errorNB7: "",
      errorNB5: "",
      errorNB3: "",
      errorNB1: "",
      error01: "",
      errorNZ2: "",
      errorNZ4: "",
      errorNZ6: "",
      errorNZ8: "",
      errorNZ9: "",
      errorNZ12: "",
      errorNZ13: "",
      errorNZ16: "",
      errorNZ17: "",

      remoteStatusNB13: "",
      remoteStatusNB11: "",
      remoteStatusNB9: "",
      remoteStatusNB7: "",
      remoteStatusNB5: "",
      remoteStatusNB3: "",
      remoteStatusNB1: "",
      remoteStatus01: "",
      remoteStatusNZ2: "",
      remoteStatusNZ4: "",
      remoteStatusNZ6: "",
      remoteStatusNZ8: "",
      remoteStatusNZ9: "",
      remoteStatusNZ12: "",
      remoteStatusNZ13: "",
      remoteStatusNZ16: "",
      remoteStatusNZ17: "",

      remoteClassNB13: "",
      remoteClassNB11: "",
      remoteClassNB9: "",
      remoteClassNB7: "",
      remoteClassNB5: "",
      remoteClassNB3: "",
      remoteClassNB1: "",
      remoteClass01: "",
      remoteClassNZ2: "",
      remoteClassNZ4: "",
      remoteClassNZ6: "",
      remoteClassNZ8: "",
      remoteClassNZ9: "",
      remoteClassNZ12: "",
      remoteClassNZ13: "",
      remoteClassNZ16: "",
      remoteClassNZ17: "",

      dataNameIdDict: {
        valveClassNB13: "6efca46d-1b13-4fa7-b8f2-9f8140786c46",
        valveClassNB11: "13276c7a-72a8-4ed0-a451-e90c34c91ad6",
        valveClassNB9: "cec98ea2-11c2-48b3-b810-1e6689b0d462",
        valveClassNB7: "b3ef696e-60dd-4006-aca8-90fabe41c9aa",
        valveClassNB5: "921ed29e-54a1-44e7-a845-21b88585abee",
        valveClassNB3: "81a50aad-208a-4304-a3aa-5181535e3fc8",
        valveClassNB1: "09b806aa-1942-4e45-adaa-0a0c0142f4c5",
        valveClass01: "9943e675-1848-48d4-8541-c1ecb1902d8c",
        valveClassNZ2: "074ffd68-38e5-4079-a00c-01dcc29d5c11",
        valveClassNZ4: "a57df0bf-9e89-456a-9c70-9fe2d246d6ba",
        valveClassNZ6: "986dbe7a-e3cd-416b-9e63-33c316474fe7",
        valveClassNZ8: "1d4e87a2-7a6a-4a21-9d7b-29b0214717c1",
        valveClassNZ9: "871f0f74-c74a-42e3-99ae-7a06f3a23b7b",
        valveClassNZ12: "45379189-a112-4354-a844-73ae3d589524",
        valveClassNZ13: "fd119cda-ac46-4449-860f-341002c17dbc",
        valveClassNZ16: "abce7e30-15bf-477b-999d-acbc7b955486",
        valveClassNZ17: "5b666e55-27e5-40d3-9d8e-62726a0f8f19",
      },

      dataNameErrorNameDict: {
        valveClassNB13: "errorNB13",
        valveClassNB11: "errorNB11",
        valveClassNB9: "errorNB9",
        valveClassNB7: "errorNB7",
        valveClassNB5: "errorNB5",
        valveClassNB3: "errorNB3",
        valveClassNB1: "errorNB1",
        valveClass01: "error01",
        valveClassNZ2: "errorNZ2",
        valveClassNZ4: "errorNZ4",
        valveClassNZ6: "errorNZ6",
        valveClassNZ8: "errorNZ8",
        valveClassNZ9: "errorNZ9",
        valveClassNZ12: "errorNZ12",
        valveClassNZ13: "errorNZ13",
        valveClassNZ16: "errorNZ16",
        valveClassNZ17: "errorNZ17",
      },

      dataNameRemoteStatusNameDict: {
        valveClassNB13: "remoteStatusNB13",
        valveClassNB11: "remoteStatusNB11",
        valveClassNB9: "remoteStatusNB9",
        valveClassNB7: "remoteStatusNB7",
        valveClassNB5: "remoteStatusNB5",
        valveClassNB3: "remoteStatusNB3",
        valveClassNB1: "remoteStatusNB1",
        valveClass01: "remoteStatus01",
        valveClassNZ2: "remoteStatusNZ2",
        valveClassNZ4: "remoteStatusNZ4",
        valveClassNZ6: "remoteStatusNZ6",
        valveClassNZ8: "remoteStatusNZ8",
        valveClassNZ9: "remoteStatusNZ9",
        valveClassNZ12: "remoteStatusNZ12",
        valveClassNZ13: "remoteStatusNZ13",
        valveClassNZ16: "remoteStatusNZ16",
        valveClassNZ17: "remoteStatusNZ17",
      },

      dataNameRemoteClassNameDict: {
        valveClassNB13: "remoteClassNB13",
        valveClassNB11: "remoteClassNB11",
        valveClassNB9: "remoteClassNB9",
        valveClassNB7: "remoteClassNB7",
        valveClassNB5: "remoteClassNB5",
        valveClassNB3: "remoteClassNB3",
        valveClassNB1: "remoteClassNB1",
        valveClass01: "remoteClass01",
        valveClassNZ2: "remoteClassNZ2",
        valveClassNZ4: "remoteClassNZ4",
        valveClassNZ6: "remoteClassNZ6",
        valveClassNZ8: "remoteClassNZ8",
        valveClassNZ9: "remoteClassNZ9",
        valveClassNZ12: "remoteClassNZ12",
        valveClassNZ13: "remoteClassNZ13",
        valveClassNZ16: "remoteClassNZ16",
        valveClassNZ17: "remoteClassNZ17",
      },

      stationIdList: ["5d3d3f64-cae8-4216-8fda-cd38c3cbcf1e", "17790481-8c80-4615-9a98-b844013ac9e9"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      let remoteStatusRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
        remoteStatusRequestList.push(this.$http.get("/remoteControl/DeviceRemoteControlStatus?stationId=" + stationId));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );

      this.$http.all(remoteStatusRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setRemoteStatus(res.data);
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    setRemoteStatus(remoteStatusData) {
      let processedRemoteData = {};
      remoteStatusData.forEach((dataItem) => {
        processedRemoteData[dataItem.deviceId] = dataItem;
      });

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        const remoteStatusName = this.dataNameRemoteStatusNameDict[dataName];
        const remoteClassName = this.dataNameRemoteClassNameDict[dataName];
        if (processedRemoteData[dataId] !== undefined) {
          let remoteStatusItem = processedRemoteData[dataId];

          let remoteStatusResult = "";
          let remoteClassResult = "";
          if (!remoteStatus.isRemoteMissionInProgress) {
            remoteStatusResult = "IDLE";
          } else if (remoteStatusItem.isRemoteMissionInProgress && !remoteStatusItem.isRemoteMissionOverridePossible) {
            remoteStatusResult = "IN_PROGRESS";
            remoteClassResult = "remote";
          } else if (remoteStatusItem.isRemoteMissionInProgress && !remoteStatusItem.isRemoteMissionOverridePossible) {
            remoteStatusResult = "IN_PROGRESS_CAN_OVERRIDE";
            remoteClassResult = "remote";
          }

          this[remoteStatusName] = remoteStatusResult;
          this[remoteClassName] = remoteClassResult;
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-valve-sign-default {
  0% {
    background-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    background-color: #ffff00;
  }
}
@keyframes breathee-remote-in-progress {
  0% {
    border-color: rgba(075, 160, 240, 0.3);
  }
  100% {
    border-color: #4ba0f0;
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine_south.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 255px;
          left: 335px;
        }

        .station-block-right {
          top: 255px;
          left: 843px;
        }

        .station-block-tower {
          top: 230px;
          left: 586px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            & .segment-name {
              font-size: 25px;
              margin-bottom: 4px;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .sta-left-left {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-left-right {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-left {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-right {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-tower {
          top: 230px;
          left: 590px;
          &::before {
            bottom: 7px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 24px;
            left: -40px;
          }
          .state-info {
            right: 40px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .valve-sign {
          margin-top: auto;
          margin-bottom: auto;
          width: 12px;
          height: 12px;
          background-color: #ffff00;
          animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
          border-radius: 10px;

          &.open {
            background-color: #67dd34;
            animation: none;
          }
          &.closed {
            background-color: #a0a0a0;
            animation: none;
          }
          &.switching {
            background-color: #4ba0f0;
            animation: none;
          }
        }

        .sign-container {
          & > p {
            margin: 0;
            white-space: nowrap;
            white-space: nowrap;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            &:first-child {
              font-size: 13px;
            }
          }
        }

        .sensor-nb13 {
          top: 263px;
          left: 178px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb11 {
          top: 263px;
          left: 238px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb9 {
          top: 263px;
          left: 288px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb7 {
          top: 263px;
          left: 340px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb5 {
          top: 263px;
          left: 390px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nb3 {
          top: 263px;
          left: 446px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb1 {
          top: 263px;
          left: 503px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-01 {
          top: 263px;
          left: 544px;
          &::before {
            bottom: 128px;
            left: -126px;
            width: 250px;
            transform: rotate(86deg);
          }
          &::after {
            bottom: 252px;
            left: -26px;
          }
          .state-info {
            right: 39px;
            top: -237px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz2 {
          top: 263px;
          left: 612px;
          &::before {
            bottom: 134px;
            left: -109px;
            width: 255px;
            transform: rotate(95deg);
          }
          &::after {
            bottom: 260px;
            left: 29px;
          }
          .state-info {
            right: -122px;
            top: -245px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz4 {
          top: 263px;
          left: 665px;
          &::before {
            bottom: 127px;
            left: -80px;
            width: 250px;
            transform: rotate(107deg);
          }
          &::after {
            bottom: 246px;
            left: 81px;
          }
          .state-info {
            right: -172px;
            top: -231px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz6 {
          top: 263px;
          left: 717px;
          &::before {
            bottom: 127px;
            left: -80px;
            width: 250px;
            transform: rotate(107deg);
          }
          &::after {
            bottom: 246px;
            left: 81px;
          }
          .state-info {
            right: -172px;
            top: -231px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz8 {
          top: 263px;
          left: 770px;
          &::before {
            bottom: 105px;
            left: -59px;
            width: 210px;
            transform: rotate(112deg);
          }
          &::after {
            bottom: 203px;
            left: 84px;
          }
          .state-info {
            right: -177px;
            top: -188px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz9 {
          top: 263px;
          left: 801px;
          &::before {
            bottom: 103px;
            left: -54px;
            width: 200px;
            transform: rotate(112deg);
          }
          &::after {
            bottom: 195px;
            left: 83px;
          }
          .state-info {
            right: -177px;
            top: -180px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz12 {
          top: 263px;
          left: 875px;
          &::before {
            bottom: 89px;
            left: -40px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 171px;
            left: 101px;
          }
          .state-info {
            right: -197px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz13 {
          top: 263px;
          left: 907px;
          &::before {
            bottom: 89px;
            left: -40px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 171px;
            left: 101px;
          }
          .state-info {
            right: -197px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz16 {
          top: 263px;
          left: 983px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 66px;
          }
          .state-info {
            right: -162px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-nz17 {
          top: 263px;
          left: 1015px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 66px;
          }
          .state-info {
            right: -162px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-t4 {
          top: 30px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t3 {
          top: 80px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t2 {
          top: 130px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t1 {
          top: 180px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>